var installedModules = {};
var moduleToHandlerMapping = {
	4137: {
		getter: () => (Promise.all([__webpack_require__.e(9968), __webpack_require__.e(5904), __webpack_require__.e(8008), __webpack_require__.e(2076), __webpack_require__.e(9148)]).then(() => (() => (__webpack_require__(9148))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	9968: {
		getter: () => (Promise.all([__webpack_require__.e(5361), __webpack_require__.e(3393)]).then(() => (() => (__webpack_require__(3393))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.5.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	5904: {
		getter: () => (Promise.all([__webpack_require__.e(5361), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(3620))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.5.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	2507: {
		getter: () => (Promise.all([__webpack_require__.e(9968), __webpack_require__.e(3935)]).then(() => (() => (__webpack_require__(3935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	2874: {
		getter: () => (Promise.all([__webpack_require__.e(6191), __webpack_require__.e(9736), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	6191: {
		getter: () => (Promise.all([__webpack_require__.e(9968), __webpack_require__.e(5904), __webpack_require__.e(1298)]).then(() => (() => (__webpack_require__(1298))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	3837: {
		getter: () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(4456))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	3743: {
		getter: () => (Promise.all([__webpack_require__.e(2874), __webpack_require__.e(2224)]).then(() => (() => (__webpack_require__(2224))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	2145: {
		getter: () => (Promise.all([__webpack_require__.e(5904), __webpack_require__.e(6191), __webpack_require__.e(3743), __webpack_require__.e(847)]).then(() => (() => (__webpack_require__(847))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/core",
	},
	189: {
		getter: () => (__webpack_require__.e(1134).then(() => (() => (__webpack_require__(1134))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/pro-regular-svg-icons",
	},
	1977: {
		getter: () => (Promise.all([__webpack_require__.e(9736), __webpack_require__.e(6311), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(3835))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser/animations",
	},
	5362: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(37), __webpack_require__.e(7855), __webpack_require__.e(3482), __webpack_require__.e(3718), __webpack_require__.e(7013)]).then(() => (() => (__webpack_require__(7013))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/ui",
	},
	5689: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(6127))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^10.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngneat/until-destroy",
	},
	6165: {
		getter: () => (__webpack_require__.e(559).then(() => (() => (__webpack_require__(559))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/pro-solid-svg-icons",
	},
	6987: {
		getter: () => (__webpack_require__.e(4106).then(() => (() => (__webpack_require__(4106))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/datetime",
	},
	3718: {
		getter: () => (__webpack_require__.e(8836).then(() => (() => (__webpack_require__(8836))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/angular-fontawesome",
	},
	599: {
		getter: () => (__webpack_require__.e(4254).then(() => (() => (__webpack_require__(4254))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@microsoft/signalr",
	},
	3273: {
		getter: () => (Promise.all([__webpack_require__.e(5904), __webpack_require__.e(2874), __webpack_require__.e(3837), __webpack_require__.e(3743), __webpack_require__.e(6897), __webpack_require__.e(8747)]).then(() => (() => (__webpack_require__(8747))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@acadv/shared/services",
	},
	1600: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(37), __webpack_require__.e(7855), __webpack_require__.e(3482), __webpack_require__.e(9792)]).then(() => (() => (__webpack_require__(9792))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/dialog",
	},
	3535: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(5675))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@aca/cookies",
	},
	4004: {
		getter: () => (__webpack_require__.e(3213).then(() => (() => (__webpack_require__(3213))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fullstory/browser",
	},
	4030: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(9922)]).then(() => (() => (__webpack_require__(9922))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/badge",
	},
	4049: {
		getter: () => (__webpack_require__.e(320).then(() => (() => (__webpack_require__(320))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@acadv/shell/core",
	},
	4214: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(37), __webpack_require__.e(7855), __webpack_require__.e(2511), __webpack_require__.e(7284)]).then(() => (() => (__webpack_require__(7284))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/menu",
	},
	7697: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(9074))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	9124: {
		getter: () => (Promise.all([__webpack_require__.e(6319), __webpack_require__.e(37), __webpack_require__.e(2511), __webpack_require__.e(1991)]).then(() => (() => (__webpack_require__(1991))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/slide-toggle",
	},
	9691: {
		getter: () => (__webpack_require__.e(2223).then(() => (() => (__webpack_require__(2223))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^14.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-select/ng-select",
	},
	5091: {
		getter: () => (() => (__webpack_require__(2867))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/di",
	},
	8471: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8070))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	6311: {
		getter: () => (__webpack_require__.e(962).then(() => (() => (__webpack_require__(962))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.2.20",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations/browser",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"1615": [
		599,
		3273
	],
	"2145": [
		2145
	],
	"2507": [
		2507
	],
	"2678": [
		1600,
		3535,
		4004,
		4030,
		4049,
		4214,
		7697,
		9124,
		9691
	],
	"2874": [
		2874
	],
	"3718": [
		3718
	],
	"3743": [
		3743
	],
	"3837": [
		3837
	],
	"4137": [
		4137
	],
	"5904": [
		5904
	],
	"6191": [
		6191
	],
	"6311": [
		6311
	],
	"6897": [
		189,
		1977,
		5362,
		5689,
		6165,
		6987
	],
	"9148": [
		5091,
		8471
	],
	"9968": [
		9968
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}